// Constants
import { DEFAULT_BILL_METRICS } from '../constants/metrics';

export function SetBillMetrics(data) {
  return {
    type: 'SET_BILL_METRICS',
    billMetrics: data || DEFAULT_BILL_METRICS,
  };
}
